<template>
  <div>
    <!-- Header -->
    <header :class="{ isScrolled: isScrolled }">
      <div class="header-container">
        <!-- Mobile Burger Menu -->
        <div class="burger-menu-container mobile-only">
          <button class="burger-menu" @click="toggleMobileMenu">
            <v-icon size="32">mdi-menu</v-icon>
          </button>
        </div>

        <!-- Logo Section -->
        <div class="logo-section">
          <a href="/" rel="noopener noreferrer">
            <img src="../assets/JG-logo.svg" alt="Jogo Global Logo" class="jg-logo" srcset="../assets/JG-logo.svg" />
          </a>
        </div>
      </div>

      <!-- Logout Button -->
      <div class="logout-container">
        <LogoutButton />
      </div>
    </header>
  </div>
</template>

<script>
import LogoutButton from '../components/LogoutButton.vue';

export default {
  name: "LoggedHeader",
  components: { LogoutButton },
  data() {
    return {
      isScrolled: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.$emit('mobile-menu-toggle', true);
    },
    handleScroll() {
      if (window.scrollY > 50) {
        this.isScrolled = true;
      }
      if (window.scrollY < 50) {
        this.isScrolled = false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

.isScrolled {
  top: 0 !important;
  transition: 0.5s ease-in;
}

header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  min-height: 60px;
  background: #2D3442;
  color: white;
  border-bottom: 4px solid transparent;
  border-image: linear-gradient(90deg,
      #faac4b 0%,
      #f9a74a 5.12%,
      #f89947 11.12%,
      #f58142 17.55%,
      #f2613b 24.29%,
      #ed3732 31.2%,
      #ed3431 31.61%,
      #e8303d 36.89%,
      #da265b 46.33%,
      #c5168c 58.5%,
      #bc1e91 62.08%,
      #a3339d 68.87%,
      #7b55b2 76.95%,
      #4384cf 87.04%,
      #00bcf1 98.77%);
  border-image-slice: 1;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.logo-section {
  flex-shrink: 0;
  
  a {
    display: flex;
    align-items: center;
  }
  
  .jg-logo {
    width: 240px;
    height: auto;
  }
}

/* Mobile Elements */
.mobile-only {
  display: none;
}

.burger-menu-container {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.burger-menu {
  background: transparent;
  border: none;
  color: white !important;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  .v-icon {
    color: white !important;
  }
}



@media screen and (max-width: 768px) {
  .mobile-only {
    display: block !important;
  }
  
  .header-container {
    padding: 0 60px 0 60px;
    justify-content: center;
  }
  
  .logo-section .jg-logo {
    width: 150px;
  }
  
  .burger-menu-container {
    left: 15px;
  }
}

@media screen and (max-width: 480px) {
  .header-container {
    padding: 0 50px 0 50px;
  }
  
  .logo-section .jg-logo {
    width: 130px;
  }
  
  .burger-menu-container {
    left: 10px;
  }
}

.logout-container {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
